import type { QuestionAnswersPdfDto } from '@zg-rentals/ts-capps-client';
import { nameCase } from '@foundernest/namecase';

type ApplicantNameFields = 'firstName' | 'middleName' | 'lastName';

export function getApplicantName(
  answers: { [key in ApplicantNameFields]?: QuestionAnswersPdfDto[key] | null } | undefined,
) {
  if (!answers) {
    return 'Name not provided';
  }
  const { firstName, middleName, lastName } = answers;
  if (firstName || middleName || lastName) {
    return nameCase([firstName, middleName, lastName].filter(Boolean).join(' '));
  }
  return 'Name not provided';
}
